import React, {useState} from 'react'
import { NavLink, useNavigate } from "react-router-dom";
import LoginBanner from '../images/loginbg.png';
import Row from "react-bootstrap/Row";

import LangSwitcher from './common/LanguageSwitcher';
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { useFormik} from "formik";
import axios from "axios";
import swal from "sweetalert";

export default function ForgotPassword() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const validationSchema = Yup.object().shape({
    email: Yup.string().required(t('validation_email_empty')).email(t('validation_email_invalid')),    
  });
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema,
    // validateOnChange: false,
    // validateOnBlur: false,
    onSubmit: async (data) => {
       console.log('input data')
      await axios       
        .post(process.env.REACT_APP_API_KEY+"api/forgot-password", data, {headers: {
          "Content-type": "Application/json",
          "sellang": localStorage.getItem("selectLang")
          }   
          })
        .then((res) => {
          if (res.data.status === true) {
             swal({
               title: "Wow!",
               text: res.data.message,
               icon: "success",
               button: "Okay",
             });
            
          } else {
            swal("Oops", "Invalid email address please try again.", "error");
          }
          console.log(res.data.message);
        }).catch(error => {
          swal("Oops", "Invalid email address please try again.", "error");
          console.log('aya',error.response);
      });
     // console.log(JSON.stringify(data, null, 2));

    },
  });
  
  const backAction = () => {
      navigate("/");
  }
  return (
    <>
      <div className="forgot-password">
          <div className="login">
          <div className="d-flex flex-column-reverse flex-md-row">
            <div className="w-100 w-md-40">
              <div className="login-form-container">

                <div className="position-relative main-left-form">
                <div className="login-head">
                  <LangSwitcher/>
                </div>
                  <div className="login-form-head">
                    <div className="form-heading">
                      <h3>{t('forgot_heading1')}</h3>
                      <p>{t('forgot_heading2')}</p>
                    </div>
                  </div>
                  <div className="login-form">
                    <div className="main-form m-0">
                      <div>
                      <form className="row g-3" onSubmit={formik.handleSubmit}>
                          <div className="mb-3">
                            <label for="email">{t('forgot_email')}<span className="text-danger">*</span>
                            </label>
                            <input name="email" type="text" id="email" className="form-control" onChange={formik.handleChange}/>
                        <div className="text-danger">
                          {formik.errors.email ? formik.errors.email : null}
                        </div>
                          </div>
                       
                          <div className="login-btn-box d-flex">
                            <button type="button" onClick={backAction} className="btn btn-red-bg btn-md nav-btn fill back-btn">{t('reset_button_back')}</button>
                            <button type="submit" className="btn btn-red-bg btn-md">{t('forgot_submit_btn')}</button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-100 w-md-60">
              <div className="right-box">
                <img src={LoginBanner} alt="" className="img-fluid login-bg" />
                <div className="banner-text px-4">
                  <div>
                    <p id="welcome">{t('forgot_welcome')}</p>
                    <p>{t('forgot_msg')}</p>
                    <div id="line"></div>
                    <span>{t('forgot_line_msg')}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
     
      </div>
    </>
  );
}
